import { createAsyncThunk } from "@reduxjs/toolkit";
import { getNotificationSummary, readAllNotifications } from "../../services/notificationService";

/**
 * Thunk to fetch notification summary counts
 */
export const fetchNotificationSummaryThunk = createAsyncThunk(
    "notification/fetchSummary",
    async (_, { rejectWithValue }) => {
        try {
            const response = await getNotificationSummary();
            if (response && response.status && response.data) {
                return response.data;
            }
            return rejectWithValue("Invalid API response format");
        } catch (error) {
            return rejectWithValue(error.message || error || "Failed to fetch summary");
        }
    }
);

/**
 * Thunk to mark notifications as read (optionally by category type)
 * Automatically dispatches summary refresh upon success.
 */
export const readAllNotificationsThunk = createAsyncThunk(
    "notification/readAll",
    async (type, { rejectWithValue, dispatch }) => {
        try {
            const response = await readAllNotifications(type);
            // Refresh counts
            dispatch(fetchNotificationSummaryThunk());
            return response;
        } catch (error) {
            return rejectWithValue(error.message || error || "Failed to mark notifications as read");
        }
    }
);

/**
 * Handle incoming live notification event
 * UI side-effects (sound, toast) are handled in the Layout/Socket layer.
 * Redux action simply processes the notification event data.
 */
export const handleNotification = createAsyncThunk(
    "notification/handle",
    async (data, { dispatch }) => {
        return data;
    }
);